var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3095 1.72476C13.6024 1.43186 14.0772 1.43186 14.3701 1.72476L17.3701 4.72476C17.663 5.01765 17.663 5.49253 17.3701 5.78542L14.3701 8.78542C14.0772 9.07831 13.6024 9.07831 13.3095 8.78542C13.0166 8.49252 13.0166 8.01765 13.3095 7.72476L15.7791 5.25509L13.3095 2.78542C13.0166 2.49252 13.0166 2.01765 13.3095 1.72476Z",
    fill: "#131518"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33984 6.00508C5.7431 6.00508 5.17081 6.24213 4.74885 6.66409C4.32689 7.08604 4.08984 7.65834 4.08984 8.25508V9.00508C4.08984 9.41929 3.75405 9.75508 3.33984 9.75508C2.92563 9.75508 2.58984 9.41929 2.58984 9.00508V8.25508C2.58984 7.26052 2.98493 6.30669 3.68819 5.60343C4.39145 4.90017 5.34528 4.50508 6.33984 4.50508H16.8398C17.254 4.50508 17.5898 4.84086 17.5898 5.25508C17.5898 5.66929 17.254 6.00508 16.8398 6.00508H6.33984Z",
    fill: "#131518"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87017 10.7247C7.16306 11.0176 7.16306 11.4925 6.87017 11.7854L4.4005 14.2551L6.87017 16.7247C7.16306 17.0176 7.16306 17.4925 6.87017 17.7854C6.57728 18.0783 6.1024 18.0783 5.80951 17.7854L2.80951 14.7854C2.51662 14.4925 2.51662 14.0176 2.80951 13.7247L5.80951 10.7247C6.1024 10.4319 6.57728 10.4319 6.87017 10.7247Z",
    fill: "#131518"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8398 9.75508C17.254 9.75508 17.5898 10.0909 17.5898 10.5051V11.2551C17.5898 12.2496 17.1947 13.2035 16.4914 13.9067C15.7882 14.61 14.8344 15.0051 13.8398 15.0051H3.33984C2.92563 15.0051 2.58984 14.6693 2.58984 14.2551C2.58984 13.8409 2.92563 13.5051 3.33984 13.5051H13.8398C14.4365 13.5051 15.0088 13.268 15.4308 12.8461C15.8527 12.4241 16.0898 11.8518 16.0898 11.2551V10.5051C16.0898 10.0909 16.4256 9.75508 16.8398 9.75508Z",
    fill: "#131518"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.32041bbe2f6b35ec76001bdc6da110c4.svg";
export { ForwardRef as ReactComponent };